"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var styles_1 = require("@material-ui/styles");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var styles_2 = __importDefault(require("./styles"));
var FormSelect = function (_a) {
    var fields = _a.fields, item = _a.item, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, errors = _a.errors, overrideClasses = _a.overrideClasses;
    var _b, _c;
    var useStyles = styles_1.makeStyles(styles_2.default(overrideClasses));
    var classes = useStyles({ fontSize: item.fontSize });
    var inputLabel = react_1.default.useRef(null);
    var _d = react_1.default.useState(0), labelWidth = _d[0], setLabelWidth = _d[1];
    react_1.default.useEffect(function () {
        var _a, _b;
        setLabelWidth((_b = (_a = inputLabel === null || inputLabel === void 0 ? void 0 : inputLabel.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 200);
    }, [item.label]);
    var showError = function () {
        if (!!lodash_1.get(errors, item.error, null) && !item.disabled)
            return (react_1.default.createElement(FormHelperText_1.default, null, lodash_1.get(errors, item.error, null)));
        if (!!lodash_1.get(errors, item.stateKey, null) && !item.disabled)
            return (react_1.default.createElement(FormHelperText_1.default, null, lodash_1.get(errors, item.stateKey, null)));
        return null;
    };
    var handleChange = function (e) {
        if (setFieldValue)
            setFieldValue(item.stateKey, item.multipleSelect ? e.target.value : e.target.value);
        if (changeField)
            changeField({
                key: item.stateKey,
                value: item.multipleSelect
                    ? e.target.value
                    : e.target.value,
            });
    };
    return (react_1.default.createElement(FormControl_1.default, { variant: (item === null || item === void 0 ? void 0 : item.variant) || "outlined", fullWidth: true, error: !item.disabled &&
            (!!lodash_1.get(errors, item.stateKey, null) ||
                !!lodash_1.get(errors, item.error, null)) },
        react_1.default.createElement(InputLabel_1.default, { ref: inputLabel, id: "demo-simple-select-outlined-label" }, item.label),
        react_1.default.createElement(Select_1.default, { id: item.idHtml || item.stateKey, multiple: item.multipleSelect, native: false, labelId: "demo-simple-select-outlined-label", key: item.stateKey, name: item.stateKey, value: fields
                ? lodash_1.get(fields, item.stateKey, "")
                : lodash_1.get(values, item.stateKey, ""), renderValue: item.multipleSelect
                ? function (selected) { return selected.join(", "); }
                : undefined, onChange: handleChange, labelWidth: labelWidth, disabled: item.disabled }, item.multipleSelect
            ? (_b = item === null || item === void 0 ? void 0 : item.options) === null || _b === void 0 ? void 0 : _b.map(function (child, id) { return (react_1.default.createElement(MenuItem_1.default, { key: id, value: child.value },
                react_1.default.createElement(Checkbox_1.default, { checked: fields
                        ? lodash_1.get(fields, item.stateKey, "").indexOf(child.value) > -1
                        : lodash_1.get(values, item.stateKey, "").indexOf(child.value) > -1 }),
                react_1.default.createElement(ListItemText_1.default, { primary: child.label }))); }) : [
            !item.selectCantBeNull && react_1.default.createElement(MenuItem_1.default, { value: "" }, "\u00A0"),
            (_c = item === null || item === void 0 ? void 0 : item.options) === null || _c === void 0 ? void 0 : _c.map(function (child, id) { return (react_1.default.createElement(MenuItem_1.default, { key: id, className: classes.selectLabel, value: child.value }, child.label)); }),
        ]),
        showError()));
};
exports.default = FormSelect;
//# sourceMappingURL=GenericFormSelect.js.map